import React from "react";
import styled from "styled-components";
import { DropdownHandler } from "../DropdownHandler";

import { mediaQueries, style } from "../style";

const RevealInlineModal = styled.div`
  padding: ${style.vars.whitespace.medium};
`;
const MobileFixedBottomHandler = styled(DropdownHandler)``;

const noop = () => {
  return;
};

export type ContentProps = {
  title?: string;
  isOpen?: boolean;
  onToggle?: () => void;
  forceInlineReveal?: boolean;
  disableClickAway?: boolean;
};

export const DefaultContent: React.FC<ContentProps> = ({ isOpen = false, children }) => {
  const isMobile = !mediaQueries.mediumMin.useMatchesBreakpoint();
  return !isOpen || isMobile ? <>{children}</> : null;
};

export const RevealContent: React.FC<ContentProps> = ({
  title = "",
  isOpen = false,
  onToggle = noop,
  forceInlineReveal,
  children,
  disableClickAway,
}) => {
  const isMobile = !mediaQueries.mediumMin.useMatchesBreakpoint();

  return isMobile && !forceInlineReveal ? (
    <MobileFixedBottomHandler
      inProp={isOpen}
      mobileTitle={title}
      mobileAlignment="fixed-bottom"
      onCancel={() => {
        onToggle();
      }}
      clickAway={(e) => {
        if (!disableClickAway) {
          onToggle();
        }
        e.stopPropagation();
      }}
    >
      <RevealInlineModal>{children}</RevealInlineModal>
    </MobileFixedBottomHandler>
  ) : isOpen ? (
    <>{children}</>
  ) : null;
};
